import { defer, MonoTypeOperatorFunction, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

export const SPINNER_DELAY_MS = 1000;

export function spinnerAfterDelay<T>(
    toggle: (visible: boolean) => void,
    delayMs: number = SPINNER_DELAY_MS
): MonoTypeOperatorFunction<T> {
    return (source: Observable<T>) =>
        defer(() => {
            let shown = false;
            const timer = setTimeout(() => {
                shown = true;
                toggle(true);
            }, delayMs);

            return source.pipe(
                finalize(() => {
                    clearTimeout(timer);
                    if (shown) {
                        toggle(false);
                    }
                })
            );
        });
}
